import React from "react";
import { FORM_COUNTRY_CODES, STRING_CONSTANT } from "../../../constants/constants";
import { t } from "i18next";
import { Field } from "formik";

const FormMobileCountryCodeField = (props) => {
  const { error, touched } = props;
  
  return (
    <div className="mb-3">
      <label htmlFor="mobile" className="form-label">
        {t("mobile")}
      </label>
      <div className="input-group">
        <Field
          as="select"
          className="form-select"
          id="countryCode"
          name="countryCode"
          style={{ maxWidth: "120px" }}
        >
          {FORM_COUNTRY_CODES.map((code) => (
            <option key={code} value={code}>
              {code}
            </option>
          ))}
        </Field>
        <Field type="text" className="form-control" id="mobile" name="mobile" />
      </div>
      {error && touched ? (
        <div className="text-danger">{error}</div>
      ) : (
        STRING_CONSTANT.BLANK
      )}
    </div>
  );
};

export default FormMobileCountryCodeField;
